module.exports = __webpack_public_path__ + "img/loading.e0fa2b5a.gif";